/**
 * Normalized model for top navigation deep-search results.
 * This keeps heterogeneous entities (documents/sessions/results) in one shape.
 */

export type TopNavDeepSearchEntityType = 'document' | 'session' | 'file' | 'result';

export type TopNavDeepSearchSourcePage =
    | 'Documents Registry'
    | 'Sessions'
    | 'Extract Results';

export type TopNavDeepSearchMatchedField =
    | 'Vendor Name'
    | 'Run ID'
    | 'Status'
    | 'Session ID'
    | 'File Name'
    | 'Supplier Name'
    | 'Document ID'
    | 'Type';

export interface TopNavDeepSearchResult {
    id: string;
    title: string;
    subtitle: string;
    entityType: TopNavDeepSearchEntityType;
    sourcePage: TopNavDeepSearchSourcePage;
    route: string;
    queryParams?: Record<string, string | number | boolean>;
    matchedField: TopNavDeepSearchMatchedField;
    matchedValue: string;
    raw?: Record<string, unknown>;
}

